import styled, { css, keyframes } from "styled-components";
import { Upload, Input, Popover } from "antd";
const { Dragger } = Upload;

const spin = keyframes`

  from {
    -ms-transform: rotate(0deg);
    -moz-transform: rotate(0deg);
    -webkit-transform: rotate(0deg);
    -o-transform: rotate(0deg);
    transform: rotate(0deg);
  }
  to {
    -ms-transform: rotate(360deg);
    -moz-transform: rotate(360deg);
    -webkit-transform: rotate(360deg);
    -o-transform: rotate(360deg);
    transform: rotate(360deg);
  }

`;

export const opacity = keyframes`
  from {
    opacity: 0;
  }
  to {
    opacity: 1;
  }
`;

export const Container = styled.div`
  /* width: 100%;
  max-width: 1920px; */
  width: 100%;
  margin: 0 auto;
  padding: 16px;
  background-color: #fff;
`;

export const Section = styled.div`
  display: grid;
  gap: 3rem;
`;

export const Title = styled.h2`
  font-family: "Open Sans";
  font-weight: 600;
  font-size: 18px;
  line-height: 22px;
  letter-spacing: 0%;
  color: #002244;
  margin-bottom: ${({ marginBottom }) => (marginBottom ? marginBottom : "0")};
`;

export const FlexContainer = styled.div`
  display: flex;
  align-items: center;
  flex-direction: ${(props) => props.direction ?? "row"};
  gap: ${(props) => props.gap ?? "16px"};
  width: ${(props) => props.width ?? "100%"};
  margin-bottom: ${({ marginBottom }) => (marginBottom ? marginBottom : "0")};
  margin-top: ${({ marginTop }) => (marginTop ? marginTop : "0")};
  transition: margin 1s;

  ${({ center }) => center && `justify-content: center`};
  ${({ spaceBetween }) => spaceBetween && `justify-content: space-between`};

  ${({ animated }) =>
    animated &&
    css`
      opacity: 0;
      animation: ${opacity} 1s forwards;
    `}

  ${({ margin }) =>
    margin &&
    css`
      margin: ${margin};
    `}
`;

export const DnDUploader = styled(Dragger)`
  &.ant-upload.ant-upload-drag {
    height: 250px;
    border: 1px solid rgb(182, 188, 192);
    border-radius: 8px;

    &:hover {
      border-color: #002244;
    }

    ${({ error }) =>
      error &&
      css`
        border-color: #dc2626;
        &:hover {
          border-color: #dc2626;
        }
      `}

    .ant-upload-drag-icon {
      margin-bottom: 8px;
    }

    .ant-upload-text {
      color: #3a3c3c;
      font-family: "Inter";
      font-weight: 600;
      font-size: 18px;
      line-height: 150%;
      letter-spacing: -1%;
      margin-bottom: 4px;
    }

    .ant-upload-hint {
      font-family: "Inter";
      font-weight: 600;
      font-size: 14px;
      line-height: 150%;
      letter-spacing: 0%;
      text-decoration: underline;
      text-decoration-thickness: 0%;
      color: #11a7d9;
    }
  }
`;

export const UploaderContainer = styled.div`
  position: relative;
  background-color: #fafafa;
  height: 250px;

  .uploadcard {
    background-color: #fafafa;
    border: 1px solid rgb(182, 188, 192);
    border-radius: 8px;
    position: absolute;
    inset: 0;
    cursor: unset;
    display: flex;
    align-items: center;
    justify-content: center;
    transition: all 300ms;

    ${({ uploading }) =>
      uploading &&
      css`
        div.uploadcardcontainer {
          opacity: 0.7;
        }

        .remover {
          cursor: not-allowed !important;
        }
      `}

    div.uploadcardcontainer {
      border: 1px solid rgb(182, 188, 192);
      border-radius: 8px;
      padding: 24px;
      display: flex;
      align-items: center;
      justify-content: center;
      gap: 12px;
    }

    p {
      font-family: "Open Sans";
      font-size: 16px;
      line-height: 100%;
      letter-spacing: 0px;
      color: #444444;
      margin-bottom: 0;
      &.remover {
        font-weight: 600;
        color: #dc2626;
        cursor: pointer;
      }

      &.size {
        margin-top: 4px;
        font-weight: 600;
        font-size: 12px;
        margin-bottom: 4px;
      }
    }

    svg {
      width: 48px;
      height: 48px;

      path {
        fill: #002244;
      }
    }
  }
`;

export const Warning = styled(FlexContainer)`
  span {
    font-family: "Inter";
    font-weight: 400;
    font-size: 12px;
    line-height: 17px;
    letter-spacing: 0%;
    color: #585f74;
  }
  ${({ error }) =>
    error &&
    css`
      span {
        color: #dc2626;
      }

      svg {
        fill: #dc2626;
      }
    `}
`;

export const GridAnimated = styled.div`
  display: grid;
  grid-template-rows: 0fr;
  overflow: hidden;
  transition: grid-template-rows 450ms;

  & > div {
    min-height: 0;
    transition: visibility 450ms;
    visibility: hidden;
  }

  .up {
    margin-top: 8px;
  }

  ${({ show }) =>
    show &&
    css`
      grid-template-rows: 1fr;
      & > div {
        visibility: visible;
      }
    `}
`;

export const OptionsPopover = styled(Popover)`
  .ant-popover-inner-content {
    width: 100%;
    background-color: red;
  }
`;

export const Option = styled(FlexContainer)`
  color: #002244;
  font-family: "Inter";
  font-size: 14px;
  line-height: 22px;
  padding: 4px 16px;
  cursor: pointer;
  width: 100%;
  & svg {
    transition: opacity 300ms ease-in-out;
    opacity: 0;
  }
  gap: 8px;
  transition: background 300ms ease-in-out;

  &:hover {
    background-color: rgba(0, 34, 68, 0.2);
  }

  ${({ active }) =>
    active &&
    css`
      & svg {
        opacity: 1;
      }
    `}

  ${({ reset }) =>
    reset &&
    css`
      justify-content: center;
      border-top: 1px solid #d9d9d9;
    `}
`;

export const PopoverTrigger = styled.button`
  position: relative;
  display: flex;
  align-items: center;
  justify-content: center;
  aspect-ratio: 1 / 1;
  min-width: 43.13px;
  background-color: transparent;
  border-radius: 5px;
  border: 1px solid #d9d9d9;
  cursor: pointer;
  transition: border-color 300ms ease-in-out;

  &:hover {
    border-color: #002244;
  }

  ${({ open }) =>
    open &&
    css`
      border-color: #002244;
    `}
`;

export const Indicator = styled.div`
  display: flex;
  align-items: center;
  justify-content: center;
  font-family: "Inter";
  font-size: 12px;
  color: white;
  line-height: 100%;
  border-radius: 50%;
  background-color: rgba(0, 34, 68, 0.8);
  position: absolute;
  width: 18px;
  height: 18px;
  right: 2.5px;
  top: 2.5px;

  opacity: 0;

  ${({ show }) =>
    show &&
    css`
      animation: ${opacity} 350ms forwards;
    `};
`;

export const EmptyContainer = styled.div`
  width: 100%;
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  color: #002244;
  gap: 8px;
  margin: 90px 0px;

  animation: ${opacity} 1s forwards;

  & > svg {
    width: 48px;
    height: 48px;

    ${({ loading }) =>
      loading &&
      css`
        animation: ${spin} 1s infinite;
      `};
  }
`;

export const HighlightText = styled.p`
  margin-bottom: 0px;
  font-size: 18px;
  line-height: 22px;
  font-weight: 600;
`;

export const Text = styled.p`
  margin-bottom: 0px;
  font-family: "Inter";
  font-size: 14px;
  line-height: 22px;
  font-weight: 400;
`;

export const customStyles = {
  headRow: {
    style: {
      backgroundColor: "#f6f6f6",
    },
  },
  headCells: {
    style: {
      color: "#533d59",
      fontSize: "14px",
      fontWeight: "normal",
      fontStretch: "normal",
      fontStyle: "normal",
      textAlign: "left",
    },
  },
  rows: {
    style: {
      color: "#002244",
      fontSize: "14px",
      fontWeight: "600",
      backgroundColor: "#fff",
      "&:hover": {
        backgroundColor: "rgba(17, 167, 217, 0.05) !important",
      },
    },
  },
};

export const TableContainer = styled.div`
  max-width: calc(94vw - 32px);
  transition: all 0.3s ease-in-out;
  .rdt_Table {
    border-radius: 5px;
    border: 1px solid #e2e8f0 !important;
  }

  .rdt_Pagination {
    border-top: 0px;
  }

  div[data-column-id="actionRow"] {
    justify-content: center;
  }

  @media screen and (max-width: 1150px) {
    max-width: calc(89vw - 32px);
  }

  @media screen and (max-width: 1250px) {
    max-width: calc(90vw - 32px);
  }

  @media screen and (max-width: 1350px) {
    max-width: calc(91.5vw - 32px);
  }
  @media screen and (max-width: 1400px) {
    max-width: calc(92vw - 32px);
  }
  @media screen and (max-width: 1500px) {
    max-width: calc(93vw - 32px);
  }
`;

export const Search = styled(Input)`
  max-width: 473px;
  width: 100%;
  border-radius: 5px;
  padding: 8px 16.8px;

  & > span {
    margin-left: 2.5px;
    margin-right: 10.25px;
  }

  &.ant-input-affix-wrapper:focus,
  &.ant-input-affix-wrapper-focused {
    border-color: #002244;
    box-shadow: 0 0 0 2px rgba(0, 34, 68, 0.2) !important;
  }

  &:hover {
    border-color: #002244 !important;
  }
`;

export const ModalTitle = styled.h2`
  margin-bottom: 16px;
  font-weight: 700;
  font-size: 18px;
  line-height: 22px;
  color: rgba(0, 0, 0, 0.85);
  text-align: center;
`;

export const ModalSubtitle = styled.p`
  margin: 0;
  font-weight: 400;
  font-size: 14px;
  line-height: 22px;
  text-align: center;
  color: rgba(0, 0, 0, 0.85);

  ${(props) =>
    props.bold &&
    css`
      font-weight: 600;
    `}
`;

export const ModalButtonsWrapper = styled.div`
  margin-top: 16px;
  display: flex;
  gap: 16px;
  align-items: center;

  ${(props) =>
    props.width &&
    css`
      width: ${props.width};
    `}

  & > button {
    flex: 1;
  }
`;
